import { useMemo } from 'react';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import { defaultColumn, defaultActionsColumn, duplicateAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

import DeleteEntryWithReferences from './DeleteEntryWithReferences';
import ManageFields from './ManageFields';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />, { size: 300 }),
    defaultColumn('slug'),
    defaultColumn('step'),
    defaultColumn('conversion_step', 'Conversion Step'),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateAction, manageAction),
  ], [])
}

function deleteAction(info) {
  return <DeleteEntryWithReferences key={keyOf(info, 'delete')} info={info} />
}

function manageAction(info) {
  return <ManageFields key={keyOf(info, 'manage')} info={info} />
}
